import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from './buttons';
import './ForgotPassword.css';

const RequestSent = props => {
  const {
    onRequestClose
  } = props;

  return (
    <div>
      <div className="page-header">
        <h3>Request Sent!</h3>
      </div>
      <div className="container">
        <p>
          Our staff will review your request and you will be notified when it is approved.
        </p>
        <p>
          Requests can take up to 2 business days.
        </p>
      </div>
      <div className="login-container__footer">
        <PrimaryButton
          label="Close"
          type="submit"
          onClick={onRequestClose}
          />
      </div>
    </div>
  );
}

RequestSent.propTypes = {
  onRequestClose: PropTypes.func.isRequired
};

export default RequestSent;


// WEBPACK FOOTER //
// ./src/components/RequestSent.js